// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PrescriberSharedExternalIdModel {
    static getAttributeTypeMap() {
        return PrescriberSharedExternalIdModel.attributeTypeMap;
    }
}
PrescriberSharedExternalIdModel.discriminator = undefined;
PrescriberSharedExternalIdModel.additionalProperties = false;
PrescriberSharedExternalIdModel.attributeTypeMap = [
    {
        "name": "id",
        "baseName": "id",
        "type": "number"
    },
    {
        "name": "externalIdType",
        "baseName": "externalIdType",
        "type": "PartyExternalIdType"
    },
    {
        "name": "externalId",
        "baseName": "externalId",
        "type": "string"
    },
];
//# sourceMappingURL=prescriberSharedExternalIdModel.js.map